export enum SocketAction {
  UpdateTickers = 'UpdateTickers',
}
